import React, {} from 'react';

import Placeholder from '../placeholder';

function ListItem(props) {

  function renderListItem() {

    const { attributes, children } = props;

    const listItemAttributes = {
      ...attributes,
      className: 'list-item'
    };

    return <li {...listItemAttributes}>
      {<Placeholder element={props.element} placeholder={props.placeholder} />}
      {children}
    </li>;

  }

  function renderMain() {

    return renderListItem();

  }

  return renderMain();

}

export default ListItem;